module.exports = __webpack_public_path__ + "img/index-zlhhr3.a95578dd.png";